import { useRequest } from "@certn/api";
import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import {
  showToast,
  BasicButton,
  PrimaryButton,
  ModalTrigger,
  Modal,
} from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  TextField,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function AddTagModal() {
  const { t } = useTranslation();
  const request = useRequest();
  const [tagName, setTagName] = useState<string>();

  const { mutate } = useClientPortalAPI(`/api/internal/client-portal/tags/`);
  async function submitTag(): Promise<void> {
    try {
      await request(`/api/internal/client-portal/tags/create/`, {
        method: "POST",
        body: JSON.stringify({ name: tagName }),
      });
      mutate();
    } catch (error: any) {
      if (
        error &&
        typeof error === "object" &&
        "body" in error &&
        Array.isArray(error.body?.name) &&
        error.body?.name
      ) {
        showToast(error.body.name[0], {
          type: "error",
        });
      } else {
        showToast(t("An error occurred"), {
          type: "error",
        });
      }
      console.error(error);
    }
  }

  return (
    <ModalTrigger
      trigger={() => {
        return <BasicButton testID="add-tag">{t("Add tag")}</BasicButton>;
      }}
    >
      <Modal testID="add-tag-modal">
        <Dialog>
          {({ close }) => (
            <>
              <DialogHeader onClose={close}>{t("Create new tag")}</DialogHeader>
              <DialogContent>
                <TextField
                  label={t("Tag name")}
                  testID="new-tag-field"
                  isRequired
                  onChange={(value) => {
                    setTagName(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      submitTag();
                      close();
                    }
                  }}
                />
              </DialogContent>
              <DialogFooter>
                <BasicButton onPress={close} testID="close">
                  {t("Close")}
                </BasicButton>
                <PrimaryButton
                  testID="save"
                  onPress={() => {
                    submitTag();
                    close();
                  }}
                >
                  {t("Save")}
                </PrimaryButton>
              </DialogFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalTrigger>
  );
}
